import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';

// Get app version for cache busting
const appVersion = import.meta.env.APP_VERSION || 'dev';

i18n
  .use(HttpBackend) // Use HTTP backend for lazy loading
  .use(initReactI18next) // Passes i18n instance to react-i18next
  .init({
    backend: {
      loadPath: `/locales/{{lng}}/translation.json?v=${appVersion}`,
      requestOptions: { cache: 'no-cache' }
    },
    lng: 'el_GR', // Default language
    fallbackLng: 'el_GR',

    // Language code normalization configuration
    // By default, i18next normalizes 'el_GR' to 'el_gr' and 'en_US' to 'en_us'
    // This causes 404 errors because our directory structure uses uppercase format
    // (e.g., /locales/el_GR/ not /locales/el_gr/)
    //
    // We disable normalization to preserve exact language codes used throughout
    // our React components and backend API (el_GR, en_US)
    load: 'currentOnly', // Only load exact language code, no fallback variants
    cleanCode: false, // Disable language code cleaning/normalization

    interpolation: {
      escapeValue: false // React already escapes values
    }
  });

export default i18n;
